document.addEventListener("DOMContentLoaded", function () {

  function waitForjQuery(callback) {
    if (window.jQuery) {
      callback(window.jQuery);
    } else {
      setTimeout(() => waitForjQuery(callback), 50);
    }
  }

  waitForjQuery(function ($) {

    let userData = localStorage.getItem("geoData");

    if (userData) {
      geoHandler(JSON.parse(userData));
    } else {
      $.get("https://ipapi.co/json/", function (data) {
        localStorage.setItem("geoData", JSON.stringify(data));
        localStorage.setItem("geoDataTime", String(Date.now()));
        geoHandler(data);
      }).fail(function () {
        console.error("Geo API request failed.");
      });
    }

    function geoHandler(data) {
      var countryCode = data.country_code;
      var referrer = document.referrer;

      if (referrer === "" && countryCode === "PK") {
      }
      else if (referrer === "" && countryCode === "IN") {
        window.location.href = "https://bokitta.in";
      }
      else if (referrer === "" && countryCode === "GB") {
        window.location.href = "https://bokitta.co.uk";
      }
      else if (countryCode === "NP") {
        alert("🚫 This website is not available in your country!");
        window.location.href = "https://www.google.com";
      }
    }

  });
});